import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mic, MessageSquare, Shield, Sparkles } from 'lucide-react';

const PersonalAIVoicePage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-4 py-20">
        {/* Back Button */}
        <Link
          to="/self-phone"
          className="inline-flex items-center text-indigo-400 hover:text-indigo-300 transition-colors mb-12"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to SELF Phone
        </Link>

        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 via-purple-400 to-blue-400">
            Your Voice. Your Agent. Your Power.
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Create and train your personal Harmony Agent with your unique voice and communication style.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Mic className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Custom Voice Training</h3>
            <p className="text-gray-300">
              Create a custom Harmony Agent trained specifically on your voice patterns and communication style.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <MessageSquare className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Natural Communication</h3>
            <p className="text-gray-300">
              Communicate, command, and automate through your personal AI with natural language and voice interactions.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Shield className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Signal Protection</h3>
            <p className="text-gray-300">
              Built with signal-resonant encryption for true identity protection and secure voice communication.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Sparkles className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Evolving Capabilities</h3>
            <p className="text-gray-300">
              Access expanding voice capabilities across all Harmony-compatible apps and future integrations.
            </p>
          </motion.div>
        </div>

        {/* Additional Info */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20">
            <h3 className="text-2xl font-semibold mb-6 text-center">Voice Features</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Natural Language Processing
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Voice Pattern Recognition
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Emotional Tone Matching
                </li>
              </ul>
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Multi-Language Support
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Context-Aware Responses
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Continuous Learning
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalAIVoicePage; 